export { useSlideLessonPageNavigator } from "#use-slide-lesson-page-navigator";
